module.exports = __webpack_public_path__ + "img/dmp4.c6ec6e72.png";